<template lang="pug">
#app(wheel="lazyloadBG")
  nav
    #logo
      a(href="#main")
        img(src="./assets/logo.svg")
    label(style="border:none;")
      input(type="checkbox")
      .burger(@click="menu=!menu")
        span
        span
        span
  .menu(v-if="menu")
    ul
      a(href="#main")
        li 關於勝合
      a(href="#equip")
        li 設備資訊
      a(href="#product")
        li 產品概覽
      a(href="#contact")
        li 聯絡我們
  #main
    .ovl
      .cont
        h1 勝合印刷有限公司
        p 品管－製程通過ISO 9001:2015認證。
        p 設備－數位、平板、樹脂板、網版、冷燙、燙金，一應俱全。
        p 型態－成捲、切張；竭盡所能達成您的需求。
      p.deco Sheng Ho Printing Co., Ltd.
      .bottom
        p Tel.: +886-2-7709-3193
        p Fax: +886-2-2228-7886
        p Mail: mailroom@5178print.com
        p Add.: 新北市中和區立德街218號5樓(嘉伸印刷五樓)
  #equip
    .ovl
      .buttons
        .left(@click="click")
        .right(@click="click")
      .cards
        .card(v-for="machine in machines")
          .pic(:style="getBgi(machine.bgi)")
          .cont
            h3 {{machine.name}}
            p 印刷色數: {{machine.color}}
            p 型態: {{machine.state}}
            p 特色: {{machine.spec}}
  #product
    .ovl
      .types 請按鈕瀏覽該分類:&nbsp;
        .type(v-for="type in productTypes",@click="categorize") {{type}}
      .wrap(v-for="product in filteredProducts")
        .pro(:data-BG="product.filename", data-load="unload", :style="getBgi(product.filename)")
          .tags
            .tag(v-for="tag in product.tags") {{tag}}
  #contact
    .ovl
      .map
      .details
        .wrap
          p Tel.: +886-2-7709-3193
        .wrap
          p Fax: +886-2-2228-7886
        .wrap
          p Mail: mailroom@5178print.com
        .wrap
          p Add.: 新北市中和區立德街218號5樓(嘉伸印刷五樓)
</template>

<script>
import products from './products.json'
import machines from './machines.json'
import {
  TweenMax
} from 'gsap/TweenMax'
export default {
  name: 'app',
  data() {
    return {
      clicks: 0,
      menu: false,
      products: [],
      filteredProducts: [],
      cache: {},
      productTypes: new Set(),
      machines: [],
      cards: []
    }
  },
  methods: {
    isInBoundBox: function (el) {
      let bound = el.getBoundingClientRect()
      // get element bounds
      let vw = (window.innerWidth || document.documentElement.clientWidth)
      let vh = (window.innerHeight || document.documentElement.clientHeight)
      // get vieport height and width
      return bound.top >= 0 && bound.left >= 0 && bound.right <= vw && bound.bottom <= vh
      // return boolean of whether the element is in the viewport bound box
    },
    getBgi: function (bgi) {
      return {
        'background-image': 'url(' + './images/' + bgi + ')'
      }
    },
    click: function (evt) {
      let target = evt.target.attributes['class'].value
      // get the button class left/right
      let delta = 568
      // delta X per click
      if (target === 'left') {
        // if clicked on left css left += delta
        TweenMax.to(".cards", 0.8, {
          left: "+=" + delta + "px",
          ease: Power1.easeOut
        })
        this.clicks--
      } else if (target === 'right') {
        // if clicked on right css right -= delta
        TweenMax.to(".cards", 0.8, {
          left: "-=" + delta + "px",
          ease: Power1.easeOut
        })
        this.clicks++
      }
      let lastCard = document.querySelector('.card:last-child')
      // get the last card
      if (this.isInBoundBox(lastCard)) {
        // if last card in view port
        TweenMax.to(".cards", 0.8, {
          left: 0 + "px",
          ease: Power1.easeOut
        })
        // return to the beginning
        console.log('In the viewport!');
        this.clicks = 0
      } else if (this.clicks < 0) {
        // if clicks < 0
        TweenMax.to(".cards", 0.8, {
          left: 0 + "px",
          ease: Power1.easeOut
        })
        // return to the beginning
        this.clicks = 0
      }
    },
    lazyloadBG: function(){
      let elements = [].slice.call(document.querySelectorAll('[data-load=unload].pro'))
      // get all the [data-load=unload].pro element
      elements.forEach(element => {
        // for every element
        if(this.isInBoundBox(element)){
          // if element in boundbox
          let bgi = element.attributes['data-bg'].value
          // get background image filename
          element.style.backgroundImage='url(' + './images/' + bgi + ')'
          // set css to display the background image
          element.attributes['data-load'].value='loaded'
          // set attr "data-load" to loaded
        }
      });
    },
    categorize: function(evt){
      this.filteredProducts = []
      // empty the filteredProducts
      let keyword = evt.target.innerText
      // get the inner text of the button as the keyword
      console.log(keyword)
      this.productQuery(keyword)
      // call productQuery using keyword as the argument
      if(this.cache[keyword]){
        // if data cached
        this.filteredProducts = this.cache[keyword]
        // assign it to the filteredProducts
      }
      console.log(this.filteredProducts)
    },
    productQuery: function (keyword) {
      if(this.cache[keyword]){
        // if cache[keyword] is not empty
        this.filteredProducts = this.cache.keyword
        // assign it to the filteredProducts
        console.log('Data fetched from cache.')
        return
        // exit
      }else{
        // if cache[keyword] is empty push directly from products using for loop.
        for (var x = 0; x < this.products.length; x++) {
          for (var y = 0; y < this.products[x].tags.length; y++) {
            if (this.products[x].tags[y] === keyword) {
              this.filteredProducts.push(this.products[x])
            }
          }
        }
        this.cache[keyword] = this.filteredProducts
        // store the result into cache[keyword]
      }
    }
  },
  created() {
    this.products = products
    this.machines = machines
    // get json data
    products.forEach(product=>product.tags.forEach(tag=>this.productTypes.add(tag)))
    // extract all the tag types and store it into a set
    this.productTypes = Array.from(this.productTypes)
    // convert the set into an array

    this.productQuery('銅版紙')
    // initializing the product display
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue